import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SharedModule } from './shared/shared.module';
import { DownloadBuildComponent } from './download-build/download-build.component';
import { BrandingComponent } from './new-components/branding/branding.component';
import { OverviewComponent } from './new-components/overview/overview.component';
import { BuildParentComponent } from './new-components/build-parent/build-parent.component';
import { DownloadComponent } from './new-components/download/download.component';
import { GettingStartedComponent } from './new-components/getting-started/getting-started.component';
import { VrSectionComponent } from './new-components/vr-section/vr-section.component';
import { FooterComponent } from './new-components/footer/footer.component';
import { LoginModalComponent } from './new-components/getting-started/Modals/login-modal/login-modal.component';
import { LicenseModalComponent } from './new-components/getting-started/Modals/license-modal/license-modal.component';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        DownloadBuildComponent,
        SpinnerComponent,
        BrandingComponent,
        OverviewComponent,
        BuildParentComponent,
        DownloadComponent,
        GettingStartedComponent,
        VrSectionComponent,
        FooterComponent,
        LoginModalComponent,
        LicenseModalComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [AppRoutingModule,
        BrowserModule,
        FormsModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        })], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
